const configure = {
    state:{
        HOST: process.env.VUE_APP_BASE_URL || 'http://localhost:8080',
    },
    getters: {
              
    },
    mutations: {
        
    }
}

export default configure